import React, { useEffect } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import CustomTable from "../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { groupsListColumns } from "../../components/Columns/Groups";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";

const Groups = () => {
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: deleteGroup } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    groupGetCall()
  }, []);

  const groupGetCall = () => {
    apiCall({
      url: apiUrls.sso.getGroups,
      method: "get",
    });
  }

  const deleteGroupCall = (id) => {
    deleteGroup({
      url: apiUrls.sso.deleteGroup + id,
      method: "delete",
      // dataToSend: {name: groupName, users: userIds, roles: roleIds },
      onSuccess: () => {
        toast.success("Group Deleted successfully");
        groupGetCall()
      },
    });
  }

  const onClickCreate = () => {
    navigate("/groups/create");
  };

  const editGroupCall = (value) => {
    navigate("/groups/create", {state: value})
  }

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Groups"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          // return (
          //   <CustomButton
          //     title="Create Group"
          //     wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
          //     textClassName="text-[var(--blackColor)] pl-2"
          //     onClick={onClickCreate}
          //     icon={icons.plusBlackIcon}
          //   />
          // );
        }}
      />

      <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-10 flex flex-col justify-center px-4 py-6 gap-y-5">
        <CustomTable
          data={data}
          columns={groupsListColumns(deleteGroupCall, navigate, true, editGroupCall
          )}
          centerAlignedColumns={[
            "l1_status",
            "l2_status",
            "amount",
            "ac_status",
            "approved_amount",
          ]}
          isGlobalSearchEnable={true}
          showPageSizeChange
          featureCss="flex-wrap-reverse"
        />
      </div>
    </div>
  );
};

export default Groups;
